import React, { useEffect } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import qs from 'qs';
import { BreadCrumbs, Container, News } from '@/containers';
import { Loader, Title } from '@/components';
import getLinkProps from '@/lib/getLinkProps';
import { getCorrectName } from '@/utils';
import mindbox from '@/seo/Mindbox';

import styles from './NewsPage.module.scss';

const Pagination = dynamic(() => import('../../components/pagination'), {
	loading: () => <Loader />,
});

const NewsPage = ({ articles, meta, seo = {} }) => {
	const router = useRouter();
	const { query } = router;
	const { total, per_page, last_page } = meta || {};
	const { page = 1 } = qs.parse(query);
	const [newsHref, _newsAs, newsTitle] = getLinkProps({ type: 'news' });
	const breadCrumbsNews = [{ slug: newsHref, name: newsTitle }];

	useEffect(() => {
		mindbox.viewNews();
	}, []);

	return (
		<section className={styles.newsSection}>
			<Container>
				<div className={styles.breadCrumbs}>
					<BreadCrumbs type='news' breadcrumbs={breadCrumbsNews} />
				</div>
				<Title component='h1' mb='large'>
					{seo && seo.h1 ? getCorrectName(seo.h1) : 'Новости'}
				</Title>

				<News items={articles} />

				{total > per_page && <Pagination lastPage={last_page} currentPage={page} shallow={false} />}
			</Container>
		</section>
	);
};

export default NewsPage;
